// extracted by mini-css-extract-plugin
export var cardHeader = "_f4-0";
export var reorderHandle = "_f4-3";
export var titleArea = "_f4-1";
export var titleAreaWithHandle = "_f4-2";